<template>
  <div class="minutedatapage" ref="minutedata" :style="{ height: minuteH + 'px' }">
    <!-- 实时在线 -->
    <div class="realtopbox">
      <div class="realtop">
        <div class="realtext">实时在线</div>
        <div class="timesline">
          <Icon class="iconclock" type="md-time" />
          监测时间：{{ onlyTime || '离线' }}
        </div>
      </div>
      <div class="realbottom" v-if="realTimeList && realTimeList.length">
        <!-- status 0 正常  1 低于 2 高于 正常背景 iconcolor1 异常 iconcolor2-->
        <div class="itemoptbox" v-for="(item, index) in realTimeList" :key="index">
          <div class="itemtitle">
            <div class="devicon" :class="item.status == 0 ? 'iconcolor1' : 'iconcolor2'">
              <i class="iconfont" :class="item.icon"></i>
            </div>
            <div class="devtext">{{ item.cn_name || '' }}</div>
          </div>
          <!-- 正常 normalcolor  异常 warningcolor -->
          <div class="itemline">
            <div class="linedata warningcolor" v-if="item.status == 1">
              {{ item.value }}{{ item.unit }}<i class="icon iconfont icon-down" style="font-size: 14px" />
            </div>
            <div class="linedata warningcolor" v-else-if="item.status == 2">
              {{ item.value }}{{ item.unit }}<i class="icon iconfont icon-up-copy" style="font-size: 14px" />
            </div>
            <div class="linedata normalcolor" v-else>{{ item.value }}{{ item.unit }}</div>
          </div>
        </div>
      </div>
      <nullData v-else></nullData>
    </div>
    <!-- 日曲图 -->
    <div class="radiusdiv">
      <div class="daybrokeline">
        <div class="brokeleft">
          <div class="broketext">日曲图</div>
          <DatePicker
            v-model="tableTime"
            type="date"
            placeholder="请选择时间"
            :editable="false"
            format="yyyy-MM-dd"
            style="width: 130px"
            @on-change="getTableData"
          />
          <div class="optionlist">
            <RadioGroup v-model="btnFlag" @on-change="changeOption">
              <template v-for="(item, index) in monitorList">
                <Radio :label="item.codeId" :key="index"
                  ><span :class="btnFlag == item.codeId ? 'rideospan' : ''">{{ item.cnName }}</span></Radio
                >
              </template>
            </RadioGroup>
          </div>
        </div>
      </div>
      <!-- dataInfoLoading -->
      <div class="daybrokentable">
        <Spin v-if="dataInfoLoading" fix>
          <Icon type="ios-loading" size="18" class="demo-spin-icon-load" />
          <div>加载中...</div>
        </Spin>
        <div ref="dayBrokenTable" v-if="dayNullData"></div>
        <nullData v-else></nullData>
      </div>
    </div>

    <div class="radiusdiv">
      <!-- 历史在线 -->
      <div class="historybox">
        <div class="historyleft">
          <div class="historytext">历史在线</div>
          <historyTimeChange
            :yearTime="yearName"
            :createTime="createTime"
            @sendChangeTime="changeYear"
          ></historyTimeChange>
        </div>
        <div class="historyright">
          <DatePicker
            placement="top-end"
            v-model="historyTime"
            type="datetimerange"
            placeholder="请选择时间"
            :editable="false"
            format="yyyy-MM-dd"
            style="width: 200px; margin-right: 10px"
            @on-change="getTableData"
          />
          <Button type="primary" ghost @click="exportFile"><i class="iconfont icon-daochu"></i>导出</Button>
        </div>
      </div>
      <!-- 历史表格 -->
      <div class="tablebox">
        <Table :columns="columns2" :data="yyTableList" :loading="tbLoading" stripe></Table>
        <Page
          style="padding: 10px 0"
          show-total
          :current.sync="page"
          :page-size-opts="[20, 50, 100, 200]"
          :page-size="row"
          :total="total"
          show-sizer
          @on-change="onNextPage"
          @on-page-size-change="onPageSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts';
import { parseTime } from '@/utils/date';
import { downfile } from '@/common/common.js';
import { mathEleHeight, exportExcel, overMonth } from '@/utils/common';
import nullData from '@/components/nullData.vue';
// 历史年选择
import historyTimeChange from '@/components/historyTimeChange.vue';

export default {
  components: {
    nullData,
    historyTimeChange,
  },
  props: {
    // 排口id
    gkSiteId: {
      type: [String, Number],
      default: '',
    },
    // 公司创建时间
    companyTime: {
      type: String,
      default: '',
    },
    // 公司id
    company_id: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      timeFlag: true, // true 可以启动定时器
      createTime: '', // 公司创建时间
      compnayId: '', // 当前选中的公司id
      yearName: '', // 历史在线时间
      dayCacheList: [], // 日曲线图缓存数据
      dayNullData: true,
      dayTimeIndex: 0,
      dayTableTime: '',

      minuteH: '',
      dataInfoLoading: false, // 信息加载动画
      tbLoading: false, //表格状态
      historyTime: [], // 历史时间
      formatime: '',
      monitorList: [], // 日曲图检测项
      gkSite_id: '',
      onlyTime: '',
      page: 1,
      row: 20,
      total: 0,
      realTimeList: [], // 实时
      tableTime: new Date(), // 日曲图时间
      unit: '', //
      monitName: '',
      btnFlag: 0, // 日曲图选项
      animal: '',
      echart: '', // 日曲图图表
      columns2: [
        {
          title: '序号',
          key: 'name',
          align: 'center',
          width: 70,
        },
        {
          title: '废气',
          align: 'center',
        },
        {
          title: '烟气温度',
          align: 'center',
        },
        {
          title: '烟气湿度',
          align: 'center',
        },
        {
          title: '监测时间',
          key: 'name',
          align: 'center',
          width: 180,
        },
      ], // 表头
      yyTableList: [], // 表数据
    };
  },
  destroyed() {},
  watch: {
    gkSiteId() {
      // 获取当年年份
      this.yearName = Number(parseTime(new Date(), '{y}'));
      this.createTime = this.companyTime;
      this.compnayId = this.company_id;
      this.btnFlag = 0;
      this.timeFlag = true;
      this.getYYNowInfo();
      this.getTableData();
      this.getYYHistoryInfo(1);
    },
  },
  mounted() {
    this.getDivHeight();
  },
  methods: {
    changeYear(n) {
      this.yearName = n;

      this.getYYHistoryInfo(1);
    },
    getDivHeight() {
      this.minuteH = mathEleHeight(this.$refs.minutedata, 20);
    },
    // 分页
    onNextPage(e) {
      this.getYYHistoryInfo(e);
    },
    onPageSize(e) {
      this.row = e;
      this.getYYHistoryInfo(1);
    },
    // 时间选择
    searchTime() {},
    // 选择测试项
    changeOption() {
      for (let i = 0; i < this.monitorList.length; i++) {
        const element = this.monitorList[i];
        if (element.codeId == this.btnFlag) {
          this.unit = element.unit;
          this.monitName = element.cnName;
          this.dayTimeIndex = i;
          break;
        }
      }
      this.timeFlag = false;
      this.getTableData();
    },
    // 初始化图表
    initEcharts(dataList, dataTime, statusList) {
      this.echart = echarts.init(this.$refs.dayBrokenTable);
      this.echart.clear();
      this.echart.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          borderColor: '#FFFFFF',
          extraCssText: 'box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);',
          padding: 10,
          textStyle: {
            // 提示框浮层的文本样式。
            color: '#233C52',
            fontSize: 12,
          },
          formatter: res => {
            let opt = '';
            let status = 0;
            let icon = '';
            for (let i = 0; i < res.length; i++) {
              const element = res[i];
              if (i == 0) {
                opt += `<div>${this.formatime} ${element.axisValue}</div>`;
                status = statusList[element.dataIndex];
                if (status == 1) {
                  icon = '<i class="icon iconfont icon-down" style="font-size: 10px"/>';
                } else if (status == 2) {
                  icon = '<i class="icon iconfont icon-up-copy" style="font-size: 10px" />';
                }
              }

              opt += `<div><span>${element.seriesName}</span>：<span style="color:${
                status == 0 ? element.color : '#E72D14'
              }" >${element.value}${this.unit}${icon}</span></div>`;
            }
            return opt;
          },
        },

        color: ['#2db7f5'],
        grid: {
          left: '0%',
          right: '4%',
          bottom: '3%',
          top: '10px',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dataTime,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#aaaaaa',
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#aaaaaa',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#E1E2E7'],
              width: 1,
              type: 'deshad',
            },
          },
        },
        series: [
          {
            name: this.monitName,
            type: 'line',
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 4, //设置线条粗细
                },
              },
            },
            smooth: true,
            data: dataList,
          },
        ],
      });
    },

    /**
     * 得到在线 【实时数据】
     */
    getYYNowInfo() {
      const apis = 'gkData/findByGkSiteId2';
      this.data = {
        gkSite_id: this.gkSiteId,
        type: 2, // null  工况  1 油烟  2在线
      };

      this.realTimeList = [];
      this.onlyTime = '';
      // 开启请求
      this.$http
        .post(this.ApiUrl + apis, this.data)
        .then(res => {
          // 当list里有数据时
          const list = res.data.extend.pageInfo;
          if (res.data.extend.news === 0 && list.length > 0) {
            // // 赋值标图数据

            this.realTimeList = list;

            this.onlyTime = this.formatDateTime(list[0].receive_time); // 监测时间
          }
        })
        .catch(err => {});
    },
    // 获取日曲线图
    getTableData() {
      const apis = 'gkData/getGkDataBySiteIdCodeIdAndTime';
      this.data = {
        gkSiteId: this.gkSiteId, // 排口id
        codeId: this.btnFlag || 0, // 检测项的id
        day: parseTime(this.tableTime || new Date(), '{y}-{m}-{d}'), // 时间
        type: 2, // 0 工况  1 油烟  2在线
      };

      this.dataInfoLoading = true; // 开启加载动画
      // 开启请求
      this.$http
        .post(this.ApiUrl + apis, this.data)
        .then(res => {
          this.dataInfoLoading = false; // 关闭加载动画
          if (res.data.extend.news == 0) {
            // 图表数据
            let dataList = [];
            let dataTime = [];
            let statusList = [];
            const list = res.data.extend.dataList;
            for (let i = 0; i < list.length; i++) {
              // 获取当天的实时数据
              dataList.push(list[i].value * 1 || 0);
              dataTime.push(list[i].receive_time ? parseTime(list[i].receive_time, '{h}:{i}') : '');
              statusList.push(list[i].status);
            }
            // 将数据赋给图表数据
            // this.labelList = dataList;
            // 获取监控项
            if (res.data.extend.codeMapList && res.data.extend.codeMapList.length > 0) {
              this.monitorList = res.data.extend.codeMapList;
              // 被选中的监控项如果没有值就将第一个值赋给他
              if (!this.btnFlag) {
                this.btnFlag = res.data.extend.codeMapList[0].codeId;
                this.unit = res.data.extend.codeMapList[0].unit;
                this.monitName = res.data.extend.codeMapList[0].cnName;
                this.dayTimeIndex = 0;
                this.dayCacheList = [];
              }

              if (this.monitorList.length > 0) {
                this.dayTimeTable();
              }
            }

            // 判断是否要暂停定时器
            if (!this.timeFlag) {
              if (this.dayTableTime) {
                clearInterval(this.dayTableTime);
              }
            }
            this.formatime = parseTime(this.tableTime || new Date(), '{y}-{m}-{d}');
            // 保存数据
            this.dayCacheList[this.dayTimeIndex] = {
              dataList: dataList,
              dataTime: dataTime,
              statusList,
            };

            if (dataList.length == 0 && dataTime.length == 0) {
              this.dayNullData = false;
            } else {
              this.dayNullData = true;
              this.$nextTick(() => {
                this.initEcharts(dataList, dataTime, statusList);
              });
            }
          }
        })
        .catch(err => {
          this.dataInfoLoading = false; // 关闭加载动画
        });
    },
    // 定时切换定时器
    dayTimeTable() {
      if (this.dayTableTime) {
        clearInterval(this.dayTableTime);
      }
      this.dayTableTime = setInterval(() => {
        if (this.monitorList.length - 1 > this.dayTimeIndex) {
          this.dayTimeIndex++;
        } else {
          this.dayTimeIndex = 0;
        }
        let info = this.monitorList[this.dayTimeIndex];
        this.btnFlag = info.codeId;
        this.unit = info.unit;
        this.monitName = info.cnName;
        let datainfo = this.dayCacheList[this.dayTimeIndex];
        // 判断缓存里是否有数据
        if (datainfo && datainfo.dataList) {
          if (datainfo.dataList.length == 0 && datainfo.dataTime.length == 0) {
            this.dayNullData = false;
          } else {
            this.dayNullData = true;
            this.$nextTick(() => {
              this.initEcharts(datainfo.dataList, datainfo.dataTime, datainfo.statusList);
            });
          }
        } else {
          this.getTableData();
        }
      }, 5000);
    },
    /**
     * 得到在线 【历史数据】  渲染表格
     */
    getYYHistoryInfo(page) {
      const apis = 'gkData/findHistoryData';
      this.data = {
        gkSite_id: this.gkSiteId,
        page: page,
        row: this.row,
        type: 2,
        time: this.yearName + '',
      };
      this.tbLoading = true; // 开启加载动画
      this.columns2 = [];
      this.yyTableList = [];
      this.total = 0;
      // 开启请求
      this.$http
        .post(this.ApiUrl + apis, this.data)
        .then(res => {
          this.columns2 = [];
          this.yyTableList = [];
          if (res.data.extend.news === 0) {
            // 表中数据
            this.page = page;
            this.columns2.push({
              type: 'index',
              title: '序号',
              align: 'center',
              minWidth: 90,
              indexMethod: row => {
                return row._index + 1 + this.page * this.row - this.row;
              },
            });
            this.yyTableList = res.data.extend.dataList;
            var titleList = ''; // 存放表头数据
            if (res.data.extend.tableTitle.length > 0) {
              titleList = res.data.extend.tableTitle;
            }

            for (var i = 0; i < titleList.length; i++) {
              this.columns2.push({
                title: titleList[i],
                fixed: titleList[i] == '监测时间' ? 'right' : '',
                align: 'center',
                minWidth: titleList[i] == '监测时间' ? 180 : 130,
                render: (h, params) => {
                  let _class = '';
                  let _class1 = '';
                  let opt = '';
                  let statuflag = '';
                  // 对比有无对应数据
                  const res = params.row.data.find(values => {
                    return values.name == params.column.title;
                  });
                  // 有对应数据
                  if (res) {
                    // 状态
                    statuflag = res.status;
                    // 数值
                    opt = res.value;
                  }
                  switch (
                    statuflag // 判断值 设置对应的样式
                  ) {
                    case 1:
                      _class = 'demo-table-info-cell-value';
                      _class1 = 'icon iconfont icon-down demo-table-info-cell-value';
                      break;
                    case 2:
                      _class = 'demo-table-info-cell-value';
                      _class1 = 'icon iconfont icon-up-copy demo-table-info-cell-value';
                      break;
                  }
                  return h('div', [
                    h('span', { class: _class }, opt),
                    h('i', { class: _class1, style: { fontSize: '12px' } }),
                  ]);
                },
              });
            }
            this.total = res.data.extend.total; // 设置总页数
          } else {
            this.total = 0;
          }
          this.tbLoading = false; // 关闭加载动画
        })
        .catch(err => {
          this.tbLoading = false; // 关闭加载动画
        });
    },
    // 导出文件
    exportFile() {
      if (this.historyTime.length == 0) {
        this.$Message.warning('请选择时间段');
        return;
      }

      if (!this.gkSiteId) {
        this.$Message.warning('请选择排口');
        return;
      }

      // 不要超过四个月
      if (!overMonth(this.historyTime[0], this.historyTime[1], 4)) {
        this.$Message.warning('选择的日期请不要超过4个月');
        return;
      }

      exportExcel(this.compnayId, this.gkSiteId, this.historyTime[0], this.historyTime[1], this);
    },
  },
};
</script>

<style lang="scss" scoped>
// 滚动条宽高
.minutedatapage::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
// 滚动条背景颜色
.minutedatapage::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 5px;
}
// 滚动条颜色
.minutedatapage::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
// 鼠标移动到滚动条上颜色
.minutedatapage::-webkit-scrollbar-thumb:hover {
  background: rgb(122, 121, 121);
}
.realtopbox {
  border-radius: 0 0 8px 8px;
  background: #fff;
  padding: 0 15px;
  padding-bottom: 1px;
  margin-bottom: 15px;
}
.minutedatapage {
  width: 100%;
  overflow-y: auto;
  .realtop {
    display: flex;
    align-items: center;
    .realtext {
      display: flex;
      position: relative;
      padding-left: 14px;
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      margin-right: 30px;
    }
    .realtext::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      width: 4px;
      height: 14px;
      background-color: #0062ff;
      transform: translateY(-50%);
    }
    .timesline {
      display: flex;
      padding: 6px 8px;
      background-color: #0062ff;
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 14px;
      font-weight: bold;
      border-radius: 4px;
      .iconclock {
        font-size: 15px;
        color: #fff;
        margin-right: 5px;
      }
    }
  }
  .realbottom {
    margin-top: 15px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 15px 25px;
    margin-bottom: 15px;
    .itemoptbox {
      box-shadow: 0 0 4px #d1d0d0;
      background: #f5f5f5;
      padding-top: 15px;
      display: flex;
      flex-direction: column;
      padding-bottom: 10px;
      border-radius: 8px;
      .itemtitle {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        .devicon {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          margin-right: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          > i {
            color: #fff;
          }
        }

        .iconcolor1 {
          background-color: #19be6b;
        }
        .iconcolor2 {
          background-color: #e72d14;
        }

        .devtext {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
        }
      }
      .itemline {
        display: flex;
        justify-content: center;
        .linetit {
          margin-right: 10px;
          font-size: 14px;
          font-weight: 400;
          line-height: 28px;
          color: #5f788e;
        }
        .linedata {
          font-size: 18px;
          font-weight: bold;
          line-height: 28px;
        }
      }
    }
  }
  .daybrokeline {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
    .brokeleft {
      display: flex;
      align-items: center;
      .broketext {
        font-size: 16px;
        font-weight: bold;
        line-height: 56px;
        color: #233c52;
        position: relative;
        padding-left: 9px;
        margin-right: 36px;
        white-space: nowrap;
      }
      .broketext::before {
        position: absolute;
        content: '';
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background-color: #0062ff;
      }
      .optionlist {
        margin-left: 20px;
      }
    }
  }
  .daybrokentable {
    height: 250px;
    width: 100%;
    margin-bottom: 10px;
    position: relative;
    > div {
      height: 100%;
      width: 100%;
    }
  }
  .historybox {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .historyleft {
      display: flex;
      align-items: center;
      .historytext {
        padding-left: 9px;
        position: relative;
        font-size: 16px;
        font-weight: bold;
        line-height: 56px;
        color: #233c52;
        margin-right: 20px;
      }
      .historytext::before {
        content: '';
        width: 4px;
        height: 16px;
        background: #0062ff;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }
    .historyright {
      display: flex;
      align-items: center;
      i {
        margin-right: 5px;
        font-size: 14px;
      }
    }
  }
  .normalcolor {
    color: #19be6b;
  }
  .warningcolor {
    color: #e72d14;
  }
  .linehr {
    width: 100%;
    border-bottom: 1px solid #dcdee2;
  }
  .radiusdiv {
    background: #fff;
    padding: 0 15px;
    border-radius: 8px;
  }
  .rideospan {
    color: #2d8cf0;
  }
}
</style>
